export default __webpack_public_path__ + "static/media/about-me-banner.e70fc81d.jpg";